import { Box, Skeleton } from '@factorialco/deprecated-design-system'

const LoadingFooter = () => {
  return (
    <Box flexDirection="row" gap="s8">
      <Skeleton width="s120" height="s32" />
      <Skeleton width="s120" height="s32" />
    </Box>
  )
}

export default LoadingFooter
